"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DatePickerDesktop: ()=>DatePickerDesktop
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_index_cjs_namespaceObject = require("../../../index.cjs");
const popover_namespaceObject = require("@base-ui-components/react/popover");
function DatePickerDesktop({ mode, open, handlePopOverOpenState, inputNode, title, selected, handleCalendarChange, components, ...restProps }) {
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(popover_namespaceObject.Popover.Root, {
        open: open,
        onOpenChange: handlePopOverOpenState,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Trigger, {
                render: inputNode,
                className: ""
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Portal, {
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Positioner, {
                    sideOffset: 12,
                    align: "start",
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(popover_namespaceObject.Popover.Popup, {
                        className: "shadow-overlay-md bg-primary-1 origin-[var(--transform-origin)] rounded-xl p-4 transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[starting-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Arrow, {}),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(popover_namespaceObject.Popover.Title, {
                                className: "sr-only",
                                children: title
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_index_cjs_namespaceObject.Calendar, {
                                selected: selected,
                                handleCalendarChange: handleCalendarChange,
                                mode: mode,
                                components: components,
                                ...restProps
                            })
                        ]
                    })
                })
            })
        ]
    });
}
exports.DatePickerDesktop = __webpack_exports__.DatePickerDesktop;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DatePickerDesktop"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
